import DashboardPage from "./DashboardPage";
import PlanListPage from "./plans/PlanListPage";
import SupportRequestsPage from "./support/SupportRequestsPage";
import SignupRequestsPage from "./signup-requests/SignupRequestsPage";
import NotificationsPage from "./notifications/NotificationsPage";
import TenantListPage from "./tenant/TenantListPage";
import TenantDetailsPage from "./tenant/TenantDetailsPage";
import TransactionsListPage from "./transaction/TransactionListPage";
import TransactionDetailsPage from "./transaction/TransactionDetailsPage";
import PlanForm from "./plans/PlanForm";
import TenantForm from "./tenant/TenantForm";
import TransactionForm from "./transaction/TransactionForm";
import SettingsProfilePage from "./settings/SettingsProfilePage";
import SettingsPasswordPage from "./settings/SettingsPasswordPage";
import ReportsPage from "./ReportsPage";

export interface AdminRoute {
  path: string;
  element: React.ReactElement;
  allowedRoles?: string[];
}

export const adminRoutes: AdminRoute[] = [
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/plans/:planId/edit", element: <PlanForm /> },
  { path: "/plans/list", element: <PlanListPage /> },
  { path: "/support", element: <SupportRequestsPage /> },
  { path: "/signup-requests", element: <SignupRequestsPage /> },
  { path: "/notifications", element: <NotificationsPage /> },
  { path: "/tenant/:tenantId/edit", element: <TenantForm /> },
  { path: "/tenant/list", element: <TenantListPage /> },
  { path: "/tenant/:tenantId/details", element: <TenantDetailsPage /> },
  { path: "/transaction/:transactionId/edit", element: <TransactionForm /> },
  { path: "/transaction/list", element: <TransactionsListPage /> },
  {
    path: "/transaction/:transaction_id/details",
    element: <TransactionDetailsPage />,
  },
  // { path: "/tenants/:tenantId/tenant-users", element: <TenantUsersPage /> },
  // Kept so old bookmarks/links to the bare /settings path still land somewhere.
  { path: "/settings", element: <SettingsProfilePage /> },
  { path: "/settings/profile", element: <SettingsProfilePage /> },
  { path: "/settings/password", element: <SettingsPasswordPage /> },
  { path: "/reports", element: <ReportsPage /> },
];
